import { Props_SnippetImageContent } from './ImageContent.props'
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import SnippetLink from '../Shared/Link/Link'

const SnippetImageContent = (props: Props_SnippetImageContent) => {
    const { snippet, category, heading, image, content, repeatable_link, link } = props

    const classSnippetThemeBackground = `snippet-image-content--theme-background snippet-image-content--theme-background-${snippet.themeBackground?.value}`
    const classSnippetContentThemeBackground = `snippet-image-content--theme-content-background snippet-image-content--theme-content-background-${snippet.themeContentBackground?.value}`
    const classSnippetLayout = `snippet-image-content--layout-${snippet.layout?.value}`
    const classSnippetImageShape = `snippet-image-content--image-shape-${image.shape?.value}`
    const classHeadingVisibility: string = heading.visibility?.value ? `snippet-image-content__heading--${heading.visibility.value}` : ''
    const classHeadingSize: string = heading.size?.value ? `snippet-image-content__heading--size-${heading.size.value}` : ''
    const classLinkAlignment = link.alignment?.value ? `snippet-image-content__button-container--${link.alignment.value}` : ''

    let imageSizes = {
        width: 400,
        height: 400,
    }

    switch (image.shape?.value) {
        case 'unrestricted':
        case 'rectangle':
            imageSizes.width = 525
            imageSizes.height = 330
            break
        case 'square':
            imageSizes.width = 400
            imageSizes.height = 400
            break
        case 'small-square':
        default:
            imageSizes.width = 330
            imageSizes.height = 330
            break
    }

    return (
    <section className={`snippet-image-content ${classSnippetThemeBackground} ${classSnippetContentThemeBackground} ${classSnippetLayout} ${classSnippetImageShape}`}>
        <div className="snippet-image-content__container">
            <div className="snippet-image-content__container-background">
                <div className="snippet-image-content__container-image">
                    <img
                        loading="lazy"
                        src={image.src?.value}
                        className="snippet-image-content__image"
                        height={imageSizes.height}
                        width={imageSizes.width}
                        alt={image.alt?.value ? image.alt.value : ''}
                    />
                </div>
                <div className="snippet-image-content__container-content">
                    { category.content?.value && <p className="snippet-image-content__category">{category.content.value}</p> }
                    <h2 className={`snippet-image-content__heading ${classHeadingVisibility} ${classHeadingSize}`}>{heading.content?.value}</h2>
                     {content.content?.value &&   <div className="snippet-image-content__content">
                        {CompileMarkdown(content.content?.value)} 
                    </div>}
                    <div className={`snippet-image-content__button-container ${classLinkAlignment}`}>
                        { repeatable_link.map((link, index) => (
                            <div key={index + (link.linkHref?.value || '')} className="snippet-image-content__link">
                                <SnippetLink 
                                    linkStyles={link.linkStyle?.value} 
                                    className="snippet-image-content__link" 
                                    url={link.linkHref?.value} 
                                    target={link.linkTarget?.value}
                                >
                                    {link.linkContent?.value}
                                </SnippetLink>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </section>
    )
}

export default SnippetImageContent